import {
	deleteAdminUser,
	inviteAdminUsers,
	useDescopeAdminUsers
} from '@api/users';
import UsersTable from '@components/Users/UsersTable';
import { USERS_FIELDS } from 'constants/global';
import React from 'react';

const VISIBILITY_MODEL = {
	[USERS_FIELDS.id]: false,
	[USERS_FIELDS.version]: false,
	[USERS_FIELDS.modifiedTime]: false,
	[USERS_FIELDS.logoutTime]: false,
	[USERS_FIELDS.tenants]: false,
	[USERS_FIELDS.roles]: false
};

const AdminsTable: React.FC = () => (
	<UsersTable
		columnVisibilityModel={VISIBILITY_MODEL}
		getUsers={useDescopeAdminUsers}
		adminInvite
		uploadUsersButton={false}
		disableBatchActions
		inviteFunc={inviteAdminUsers}
		deleteFunc={deleteAdminUser}
	/>
);

export default AdminsTable;
